<app-progress-bar *ngIf="loading"></app-progress-bar>
<div *ngIf="!loading" class="container">
    <div class="title">
        <h4>Listado de Centros</h4>
        <button type="button" class="btn btn-primary" routerLink="/addCenter">Agregar Centro</button>
    </div>

    <table *ngIf="listCenters.length > 0" class="table table-hover">
        <thead>
          <tr>
            <th scope="col">Nombre</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of listCenters" class="table-active">
            <td>{{ item.name }}</td>
            <td>
                <button routerLink="/editCenter/{{ item.id }}" type="button" class="btn btn-info btn-sm">Edit</button>
                <button (click)="deleteCenter(item.id!)" type="button" class="btn btn-secondary btn-sm ms-2">Delete</button>
            </td>
          </tr>
        </tbody>
      </table>
      <h5 *ngIf="listCenters.length == 0">No hay carreras para mostrar</h5>
</div>
